<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ztxHeF/tc-custom/9781035814053.jpg?1705766066638" alt="This image is the cover for the book The Baker's Dozen: Twelve Bedtime Stories for Naughty Boys, Wayward Girls and Furry Friends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Baker's Dozen: Twelve Bedtime Stories for Naughty Boys, Wayward Girls and Furry Friends
      </h1>
      <p class="bookDescription body article font2">
        <p>Enter the extravagant world of naughty children, school bullies and nerds, fancy cats, dirty dogs, world-record holding bubble blowers, showoffs, scary teachers, hypochondriacs, lost beloved bunnies, annoying little brothers, funky potions, heroes that come in all shapes and sizes and more. You may just find that these larger-than-life characters remind you of someone you know, maybe even a little of yourself! Read at your own risk: you must know that you may laugh aloud, so be prepared to have a tissue ready or even a spare pair of undies at your disposal. Do the good guys always win? You’ll just have to wait and see. Sit on mum and dad’s knee, or maybe your older brother and sister, and turn the pages if you dare to enjoy the playful and joyous rhyming tales.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catherine Van der Woude
      </h2>
      
      <p class="authorDescription body article">Catherine is a happily married mum of three beautiful kids. She was a registered nurse for over fifteen years. After leaving work to focus on her young family, she turned her hand at other things such as medico-legal transcription and candle making. Time off had her contemplating what her true dream was, and she discovered what she already knew deep down that she loved writing. She has a collection of poetry saved on scraps of paper around her house and in the deep recesses of her laptop, only read to her family. Her true passion though is writing silly children’s rhymes, considering she has Peter Pan like qualities. When she’s not writing, you’ll find her dancing and singing in the lounge with a mega pint of crisp dry white in her hand.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0887902b